<template>
    <div v-spinner="loading" class="webim-hot-panel">
        <template v-for="(item, idx) in ctn">
            <hot-panel-text v-if="item.type === 'text'" :key="idx" v-bind="item" />
            <hot-panel-card v-if="item.type === 'card'" :key="idx" v-bind="item" />
            <hot-panel-img v-if="item.type === 'img'" :key="idx" v-bind="item" />
            <hot-panel-multi v-if="item.type === 'multiLineText'" :key="idx" v-bind="item" />
        </template>
        <v-spinner :opacity="0.5" />
    </div>
</template>

<script>
import HotPanelText from './components/hotPanelText';
import HotPanelCard from './components/hotPanelCard';
import HotPanelImg from './components/hotPanelImg';
import HotPanelMulti from './components/hotPanelMulti';

export default {
    name: 'WebimHotPanel',
    components: {
        HotPanelText,
        HotPanelCard,
        HotPanelImg,
        HotPanelMulti,
    },
    props: {
        content: {
            type: Array,
            default: null
        },
        id: {
            type: [String, Number],
            default: ''
        },
        rhinoProps: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            requestContent: [],
            loading: false
        };
    },
    computed: {
        hasContent() {
            return Boolean(this.content);
        },
        templateId() {
            const rhinoPropId = this.rhinoProps.row && this.rhinoProps.row.id;
            return this.id || rhinoPropId;
        },
        ctn() {
            return this.content || this.requestContent;
        }
    },
    watch: {
        templateId(curId, preId) {
            if (curId === preId) {
                return;
            }

            this.requestTemplateContent();
        }
    },
    created() {
        if (this.hasContent) {
            return;
        }

        this.requestTemplateContent();
    },
    methods: {
        requestTemplateContent() {
            const detailURL = '/receptionConf/sidebar/template/detail';
            const params = { id: this.templateId };
            const success = res => {
                if (res.code !== 0) {
                    throw new Error(res.message);
                }

                let { content } = res.data;
                if (typeof content === 'string') {
                    try {
                        content = JSON.parse(content);
                    } catch (e) {
                        content = [];
                        this.$message.error(`解析自定义侧边栏模板出错: ${e.message}`);
                    }
                }
                this.requestContent = content;
            };
            const failed = err => this.$message.error(err.message);

            this.showLoading(true);
            this.$ajax
                .gatewayGet(detailURL, { params })
                .then(success)
                .catch(failed)
                .finally(() => this.showLoading(false));
        },
        showLoading(needShow) {
            this.loading = needShow;
        }
    }
};
</script>

<style lang="less" scoped>
.webim-hot-panel {
    font-family: PingFang SC, Microsoft Yahei, serif;
    width: 240px;
    padding: 20px 15px;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 6px;

    section {
        margin-top: 12px;

        &:first-child {
            margin-top: 0;
        }
    }
}
</style>
